import request from '@/utils/request'

export function getHikvisionUser(staffId) {
  return request({
    url: `acms/hikvision/user/${staffId}`,
    method: 'get'
  })
}

export function createHikvisionUser(staffId) {
  return request({
    url: `acms/hikvision/user/${staffId}`,
    method: 'post',
    timeout: 100000
  })
}
